import { useBaseApiQuery } from "@query/baseQuery";

export const useEventByUuidQuery = (eventUuid) => {
    return useBaseApiQuery(
        {
            endpoint: `/event/${eventUuid}`,
        },
        {
            enabled: !!eventUuid,
            queryKey: [
                "eventByUuid",
                eventUuid
            ]
        }
    );
};

export const useAllEventsQuery = (params = {}) => {
    return useBaseApiQuery(
        {
            endpoint: `/event/all`,
        },
        {
            queryKey: [
                "allEvents",
            ]   
        }
    );
};


